import { createContext, useContext } from 'react';
import { IActions } from './actions';

export const ActionsContext = createContext({} as IActions);

export const useActions = (): IActions => useContext<IActions>(ActionsContext);
